import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";

export const getCuentasBalanceDisponibleProveedor = async (IdProveedor) => {
    const result = await PrivateInterceptorsPR(`CXP/DetalleCuentasPorPagar/CuentasBalanceDisponible/${IdProveedor}`, 'GET');
    return result;
}